import {Model, ModelMixin} from '../../../common/model.class';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class DeaRegistrationInformation extends ModelMixin() implements Model<DeaRegistrationInformation> {

    TYPE = DeaRegistrationInformation;

    noDeaExplanation?: string;

    constructor(jsonData: any = {}) {
        super();
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/dea/info/dea-registration-information.model.ts